export default {
  "REGION": "eu-west-2",
  "USER_POOL_ID": "eu-west-2_F0yUKYzu6",
  "USER_POOL_APP_CLIENT_ID": "7etgm1lhpjuibace08r35o22aq"
}
